import React from 'react';
import ReactDOM from 'react-dom';
import App from './Widget-centrum';
import { ThemeProvider } from 'emotion-theming';
import { centrum } from './themes';

window.renderElections = (id, props = {}) => {
	const root = document.getElementById(id);
	ReactDOM.render(
		<ThemeProvider theme={centrum}>
			<App {...props} />
		</ThemeProvider>,
		root
	);
};
